<template>
    <div>
        <!-- Space -->
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>

        <!-- Buscador Movil -->
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="busqueda-contenido2 visible-sm visible-xs">

                        <!-- <form role="form" @submit.prevent="simpleSearch" method="get" >
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput"  @keyup="getList" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li>
                            </ul>
                            <div class="autocomplete" v-show="isOpen" >
                                <ul class="autocomplete-results">
                                    <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                    {{ result.nameRecord }}
                                    </li>
                                </ul>
                            </div>
                            <div class="radio-ww animated slideInRight visible-sm visible-xs">
                                <label class="radio-inline">
                                    <input type="radio" v-model="selectedSearchIn"  v-on:change="getList"  value="ww">Who's Who
                                </label>
                                <label class="radio-inline">
                                    <input type="radio" v-model="selectedSearchIn"  v-on:change="getList"  value="guia">OTT
                                </label>
                            </div>
                        </form> -->

                    </div>
                    <div class="busq-avanzada">
                        <div id="busqavanzada2" class="collapse">
                            <!-- <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="country" v-model="countryIn"  >
                                            <option :value="0" selected >-- País --</option>
                                            <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                            <option  :value="0"  selected >-- Categoría --</option>
                                            <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <select class="form-control" name="activity" v-model="activityIn" >
                                            <option  :value="0"  selected >-- Actividad --</option>
                                            <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                        </select>
                                    </div>
                                </div>
                            </form> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="banner visible-lg visible-md animated slideInDown" align="center" >
            <div id="sas_76534"></div>
            <div id="sas_76538"></div>
            <div id="sas_76537"></div>
        </div>


        <!-- Contenido -->
        <div class="contenido-resultados" >
            <div class="container">
                <div class="row">
                    <app-content></app-content>

                    <!--
                    <div class="col-md-4 animated slideInRight">
                        <form role="form" @submit.prevent="simpleSearch" method="get" >
                            <div class="busqueda-contenido visible-lg visible-md">
                                <ul class="list-inline">
                                    <li style="width: 77%;"><input v-model="simpleSearchInput" @keyup="getList" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                    <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                    <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada"><i class="fa fa-plus"></i></button></li>
                                </ul>
                                <div class="autocomplete" v-show="isOpen" >
                                        <ul class="autocomplete-results">
                                            <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                            {{ result.nameRecord }}
                                            </li>
                                        </ul>
                                    </div>
                                <div class="radio-ww animated slideInRight">
                                    <label class="radio-inline">
                                        <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                                    </label>
                                    <label class="radio-inline">
                                        <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  id="ott" value="guia">OTT
                                    </label>
                                </div>
                            </div>
                        </form>
                        <div class="busq-avanzada">
                            <div id="busqavanzada" class="collapse">
                                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="country" v-model="countryIn"  >
                                                <option :value="0" selected >-- País --</option>
                                                <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                                <option  :value="0"  selected >-- Categoría --</option>
                                                <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="activity" v-model="activityIn" >
                                                <option  :value="0"  selected >-- Actividad --</option>
                                                <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="banner">
                            <div id="sas_76539"></div>
                            <div id="sas_76540"></div>
                            <div id="sas_76541"></div>
                        </div>
                    </div>
                    -->

               </div>
            </div>
        </div>
    </div>
</template>

<script>
    var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';

    import axios from 'axios';

    import Content from './otro/Content.vue';

    export default {
        name: 'Otros',
        components: {
            'app-content': Content,
        },
        data() {
            return {
                resultSearch: [],
                AdvanceSearchInput: '',
                simpleSearchInput: '',
                countries: [],
                categories: [],
                activities: [],
                categoryIn: 0,
                contactoIn: '',
                empresaIn: '',
                countryIn: 0,
                activityIn: 0,
                contactID: 0,
                contact: [],
                contactCompanies: [],
                contacts: [],
                selectedSearchIn: 'ww',
                sectionIdOld: 0,
                isOpen: false,
                contactos: [],
                permalink: 0,
                nombres: '',
            };
        },
        created() {},
        methods: {
            moment: function() {
                return moment();
            },
            redirectTo: async function(recordID, module) {
                if (recordID) {
                    this.$router.push('/' + module + '/' + recordID);
                }
            },
            isActiveSearch() {
                return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                    ? false
                    : true;
            },
            getActivity: async function() {
                if (this.categoryIn) {
                    await axios
                        .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            category: this.categoryIn,
                        })
                        .then(response => {
                            this.activities = response.data;

                            this.$nextTick(function() {});
                        });
                }
            },

            getDataForm: async function() {
                await axios
                    .post(resfulApi + 'getCountriesWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    })
                    .then(response => {
                        this.countries = response.data.countries;
                        this.categories = response.data.categories;

                        this.$nextTick(function() {});
                    });

                this.getActivity();
            },

            advanceSearch: async function(page) {
                this.currentPage = page;

                this.getContactsByAdvanceSearchWWFWS(
                    this.contactoIn +
                        '_' +
                        this.empresaIn +
                        '_' +
                        this.countryIn +
                        '_' +
                        this.categoryIn +
                        '_' +
                        this.activityIn,
                    page
                );
            },
            simpleSearch: function(e) {
                if (this.simpleSearchInput && this.isActiveSearch()) {
                    this.nombres =
                        this.nombres == '' ? this.simpleSearchInput : this.nombres;
                    this.$router.push({
                        name: 'Search',
                        params: {
                            permalink: this.permalink,
                            tipo: this.selectedSearchIn,
                            search: this.simpleSearchInput,
                            nombres: this.nombres,
                        },
                    });
                }
            },
            bannersWW: async function() {
                // Convertir nombre de sección a ID
                var id = 0;
                switch (this.section) {
                    case 'Compradores': id = 1; break;
                    case 'Distribuidores': id = 2; break;
                    case 'Productores': id = 3; break;
                    case 'Dobladores': id = 12; break;
                    case 'Ingenieros': id = 13; break;
                    default: id = parseInt(this.section) || 0;
                }
                switch (id) {
                    case 1:
                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057831, // Página : Produ.com/compradoresww
                            formatId: 76534, // Formato : leaderboard compradoresWW 1137x171
                            target: '', // Segmentación
                        });

                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057831, // Página : Produ.com/compradoresww
                            formatId: 76539, // Formato : lateral_compraWW 360x324
                            target: '', // Segmentación
                        });
                        ''; // Segmentación
                        break;

                    case 2:
                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057833, // Página : Produ.com/distibuidoresww
                            formatId: 76538, // Formato : leaderboard distribWW 1137x171
                            target: '', // Segmentación
                        });

                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057833, // Página : Produ.com/distibuidoresww
                            formatId: 76540, // Formato : lateral_distriWW 360x324
                            target: '', // Segmentación
                        });
                        break;

                    case 3:
                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057835, // Página : Produ.com/productoresww
                            formatId: 76537, // Formato : Leaderboard productoresWW 1137x171
                            target: '', // Segmentación
                        });

                        sas.call('std', {
                            siteId: 69989, //
                            pageId: 1057835, // Página : Produ.com/productoresww
                            formatId: 76541, // Formato : Lateral_produWW 360x324
                            target: '', // Segmentación
                        });
                        break;
                }
            },

            bannersWWOld: async function(sectionName) {
                // Convertir nombre de sección a ID si es necesario
                var id = 0;
                if (typeof sectionName === 'string') {
                    switch (sectionName) {
                        case 'Compradores': id = 1; break;
                        case 'Distribuidores': id = 2; break;
                        case 'Productores': id = 3; break;
                        case 'Dobladores': id = 12; break;
                        case 'Ingenieros': id = 13; break;
                        default: id = parseInt(sectionName) || 0;
                    }
                } else {
                    id = sectionName;
                }
                switch (id) {
                    case 1:
                        $('#sas_76534,#sas_76539').empty();
                        break;

                    case 2:
                        $('#sas_76538,#sas_76540').empty();
                        break;

                    case 3:
                        $('#sas_76537,#sas_76541').empty();
                        break;
                }
            },
            bannersTopWW: async function(id) {
                this.bannersWW(id);
                this.bannersWWOld(this.sectionIdOld);
            },
            getList: function() {
                this.simpleSearchInput.length > 3
                    ? this.getSearchWWFWS()
                    : (this.isOpen = false);
            },
            getSearchWWFWS: async function() {
                await axios
                    .post(resfulApi + 'getSearchWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        search: this.simpleSearchInput,
                        tipo: this.selectedSearchIn,
                    })
                    .then(response => {
                        this.contactos = response.data;
                        this.contactos.length > 0
                            ? (this.isOpen = true)
                            : (this.isOpen = false);
                    });
            },
            setResult: async function(result) {
                this.simpleSearchInput = result.nombres;
                this.permalink = result.permalink;
                this.nombres = result.nombres;
                this.isOpen = false;
                var typeSearch = this.redirectConsulta(
                    result.nameRecord,
                    result.GuiaOTT
                );
                this.$router.push('/' + typeSearch + '/' + result.permalink);
            },
        },
        beforeMount() {},
        mounted: function() {
            //$('#myModalMenu').modal('hide')
            $('body').removeClass('modal-open');

            // Usar el nombre de la ruta en lugar del parámetro
            this.section = this.$route.name;
            this.bannersTopWW(this.section);
            // this.getDataForm();
        },
        watch: {
            '$route'(newRoute, oldRoute) {
                // $('#myModalMenu').modal('hide')
                $('body').removeClass('modal-open');
                this.sectionIdOld = oldRoute ? oldRoute.name : null;
                this.section = newRoute.name;
                this.bannersTopWW(this.section);
                // this.getDataForm();
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .filtro-negro a:hover {
        cursor: pointer;
    }
    a:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Otros.vue